import Event from './Event';

class Cache extends Event {
  constructor() {
    super();
    this.cache = {};
  }

  // Get cache if still valid
  get(id) {
    if (!this.cache[id]) return null;

    let now = Date.now();

    return this.cache[id].validUntil >= now ? this.cache[id] : null;
  }

  // Set cache in seconds
  set(id, length, data) {
    let now = Date.now();

    this.cache[id] = {
      id: id,
      updated: now,
      validUntil: now + length * 1000,
      data: data,
    };
  }
}

export default Cache;
